define([
	'internal_util/Logger',
	'internal_util/Util',
	'model/Terminal',
	'amdi18n-loader?!service/nls/TerminalManager_strings'
], function (
	Logger,
	Util,
	Terminal,
	Strings
) {
	'use strict';

	/**
	 * TerminalManager class
	 */
	return function () {
		var _terminals = {};


		// private methods

		function log(method, message, data) {
			Logger.log('TerminalManager', method, message, data);
		}


		// public methods

		this.getTerminals = function () {
			return _terminals;
		};

		this.getTerminal = function (terminalId) {
			if (_terminals.hasOwnProperty(terminalId)) {
				return _terminals[terminalId];
			}

			log('getTerminal', Strings.terminal_not_found, terminalId);

			return null;
		};

		this.addTerminal = function (terminal) {
			var _name = 'addTerminal';

			if (_terminals.hasOwnProperty(terminal.id())) {
				log(_name, Strings.replaced_terminal, {old : _terminals[terminal.id()], 'new' : terminal});
			} else {
				log(_name, Strings.added_terminal, terminal);
			}

			_terminals[terminal.id()] = terminal;
		};

		this.removeTerminal = function (terminalId) {
			var _name = 'removeTerminal',
				terminal = null;

			if (_terminals.hasOwnProperty(terminalId)) {
				terminal = _terminals[terminalId];

				delete _terminals[terminalId];

				log(_name, Strings.removed_terminal, terminalId);
			} else {
				log(_name, Strings.terminal_not_found, terminalId);
			}

			return terminal;
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/TerminalManager.js
// module id = 286
// module chunks = 4